import axiosInstance from "./axiosConfig";

export const getNotifications = async () => {
  const response = await axiosInstance.get('/notifications');
  return response.data;
};

export const readAllNotification = async () =>{
  const response = await axiosInstance.patch('/notifications/mark_all_read');
  return response.data;
}

export const readNotification = async (id) => {
  const response = await axiosInstance.patch(
    `/notifications/${id}/mark_read`
  );
  return response.data;
};

export const notificationCsvDownload = async (id) =>{
  const response = await axiosInstance.get(`/notifications/${id}/download_csv`);
  return response.data;
}